export default __webpack_public_path__ + "static/media/clock.f47b89b5.svg";